import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useGeneralContext } from "../../../Contexts/GeneralContext/GeneralProvider"
import { useAdminModalContext } from "../../../Contexts/AdminModalContext/AdminModalProvider"
import { ViewSingularSchoolComponentInterface } from "../../../Interfaces/ComponentsInterfaces/AdministratorInterfaces"
import ConfirmationPopup from "../../SharedComponents/OtherComponents/ConfirmationPopUp"
import { FetchDeleteFunction } from "../../../Helpers/FetchHelpers"
import { GetSuperAdminSchoolPath } from "../../../Helpers/RouteHelpers"
import defaultSchoolImage from '../../../Assets/BasicSchoolLogo.png'
import "../../../Modals/AdminModals/AdminCSS.css"




function ViewSingularSchool({ schoolToShow = undefined }: ViewSingularSchoolComponentInterface) {

	const { adminSchools, setAdminSchools } = useAdminModalContext()
	const { setCurrentModal } = useGeneralContext()
	const navigate = useNavigate()
	const [confirmationPopUp, setConfirmationPopUp] = useState<boolean>(false)

	const handleEditClick = () => {
		if (schoolToShow) {
			setCurrentModal('SchoolEdit', schoolToShow.SK)
		}
	}

	const handleClick = () => {
		if (!schoolToShow) {
			return
		}
		navigate(GetSuperAdminSchoolPath(schoolToShow.SK))
	}

	const handleDelete = async () => {
		if (schoolToShow) {
			try {
				const url = `${process.env.REACT_APP_BACKEND_URL}/schools/${schoolToShow.SK}`
				await FetchDeleteFunction(url)
				await updateContextSchools()
				alert('Colegio eliminado correctamente')
			} catch (error) {
				alert('Hubo un problema al eliminar el colegio')
			}
		}
	}

	const updateContextSchools = async () => {
		if (schoolToShow) {
			const updatedSchools = adminSchools.filter(schoolToFilter => schoolToFilter.SK !== schoolToShow.SK)
			setAdminSchools(updatedSchools)
		}
	}

	return (
		schoolToShow ? (
			<>
				<div className="ViewSchoolDiv">
					<div className="ViewSchoolImageDiv" onClick={handleClick}>
						{(schoolToShow.profile_image && schoolToShow.profile_image.trim() !== '') ? (
							<img src={schoolToShow.profile_image} alt='Logo por defecto2' />
						) : (
							<img src={defaultSchoolImage} alt='Logo por defecto' />
						)}
					</div>
					<div className="ViewSchoolNameDiv" onClick={handleClick}>
						<h5>{schoolToShow.name}</h5>
					</div>
					<div className="ViewSchoolButtonDiv">
						<button type='button' onClick={handleEditClick}>
							Editar
						</button>
						<button type='button' onClick={() => setConfirmationPopUp(true)}>
							Borrar
						</button>
					</div>
				</div>
				{confirmationPopUp && (
					<ConfirmationPopup
						valueToConfirmate={schoolToShow.name}
						deletionType="school"
						deleteFunction={handleDelete}
						setIsPopUpVisible={setConfirmationPopUp}
					/>
				)}
			</>
		) : (
			<div className='ViewEmptySchoolDiv'></div>
		)
	)
}

export default ViewSingularSchool